import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { MissedCallsSection } from './components/MissedCallsSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { PricingSection } from './components/PricingSection';
import { AfterYouCallSection } from './components/AfterYouCallSection';
import { SocialProofSection } from './components/SocialProofSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <MissedCallsSection data-id="element-4" />
        <HowItWorksSection data-id="element-5" />
        <PricingSection data-id="element-6" />
        <AfterYouCallSection data-id="element-7" />
        <SocialProofSection data-id="element-8" />
        <FAQSection data-id="element-9" />
        <FinalCTASection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}